import { createScriptRequestQueue } from './script_request_queue';

var scriptRequestQueue = createScriptRequestQueue();

function fetchScript(url, params) {
  scriptRequestQueue.enqueue(url, params);
}

var widgetPriceCompactInitialize = function() {
  var cardsArray = [];
  document.querySelectorAll(".widget-price-compact-placeholder").forEach(function(el) {
    cardsArray.push(el.dataset.card);
  });
  if (cardsArray.length > 0) {
    var chunk = 25;
    for (var i = 0; i < cardsArray.length; i += chunk) {
      var tempArray = cardsArray.slice(i, i + chunk);
      fetchScript("/widgets/price_compact/js", { cards: tempArray });
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  widgetPriceCompactInitialize();
});
